const API_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

export async function login(email, password) {
  const res = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    throw new Error("Login fallido");
  }

  const data = await res.json();
  localStorage.setItem("token", data.token);
  return data.token;
}

export function getToken() {
  return localStorage.getItem("token");
}

export function logout() {
  localStorage.removeItem("token");
}

export async function requestPasswordReset(email) {
  const res = await fetch(`${API_URL}/forgot`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  // siempre 200: muestra mensaje genérico
  return res.json();
}

export async function resetPassword(token, password) {
  const res = await fetch(`${API_URL}/reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'No se pudo restablecer');
  return data;
}
